"use client";

import {
  faApple,
  faGooglePlay,
  faWindows,
} from "@fortawesome/free-brands-svg-icons";
import { motion } from "framer-motion";
import ServiceLink from "@/shared/app/ui/link/ServiceLink";
//service/wemap

export default function DownLoadSection() {
  return (
    <>
      {/* 다운로드 section */}
      <div className="bg-[#131521] py-6 text-white">
        <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-14 md:py-20 flex flex-col justify-center items-center">
          {/* 타이틀 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex flex-row items-center text-center justify-center mb-14 md:mb-20">
              <span
                className="text-lg text-white mr-4 md:mr-10 w-9 h-9 md:w-11 md:h-11 rounded-lg md:rounded-2xl bg-[#DA6363] items-center flex justify-center"
                style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
              >
                1
              </span>
              <p
                className="text-xl md:text-3xl text-white tracking-tight"
                style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
              >
                위맵은 왜 만들어졌을까요?
              </p>
            </div>
          </motion.div>
          {/* 내용 텍스트 */}
          <motion.div
            className="text-center max-w-full xl:max-w-[940px]  space-y-[1px]"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={{
              hidden: {},
              visible: { transition: { staggerChildren: 0.15 } },
            }}
          >
            {[
              "휠체어를 이용하는 이동약자들도 친구들과 카페에서 수다 떨고, 맛집도 가고, 쇼핑도 하고 싶습니다.",
              `하지만 <span class="text-[#E0FF18]"   style={{ fontFamily: '"pre-SemiBold", sans-serif' }}>“입구에 턱이 있을까?”, “휠체어용 화장실은 있을까?”</span> 처럼 매번 확인해야 할 정보가 너무 많죠.`,
              "위맵은 이런 불편함을 줄이기 위해 만들어졌습니다.",
              "식당, 카페, 쇼핑시설 등 다양한 장소의 편의시설 정보를 한눈에 확인할 수 있도록 정리했습니다.",
              "이제는 검색만으로 나에게 맞는 공간을 쉽게 찾을 수 있어요.",
              "누구에게나 열려 있는 도시, 위맵이 함께 만들어갑니다.",
            ].map((text, idx) => (
              <motion.p
                key={idx}
                className="text-sm md:text-base xl:text-xl tracking-tighter mb-2 text-light-80"
                variants={{
                  hidden: { opacity: 0, y: 10 },
                  visible: { opacity: 1, y: 0 },
                }}
                transition={{ duration: 0.5 }}
                dangerouslySetInnerHTML={{ __html: text }}
                style={{ fontFamily: '"pre-Medium", sans-serif' }}
              />
            ))}
          </motion.div>
          {/* 다운로드 링크 */}
          <motion.div
            className="  flex w-full flex-col md:flex-row justify-center mt-10 md:mt-14  space-x-0 md:space-x-4 gap-y-3"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <ServiceLink
              icon={faApple}
              smallText="Available on the"
              bigText="App Store"
              href="https://apps.apple.com/kr/app/%EC%9C%84%EB%A7%B5/id6499096342"
            />
            <ServiceLink
              icon={faGooglePlay}
              smallText="GET IT ON"
              bigText="Google Play"
              href="https://play.google.com/store/apps/details?id=kr.wemap&hl=ko"
            />
            <ServiceLink
              icon={faWindows}
              smallText="Website link"
              bigText="Web Site"
              href="https://www.we-map.kr/service/main"
            />
          </motion.div>
        </div>
      </div>
      {/* 라운드 */}
      <div className="relative h-24 md:h-32 ">
        <div className="absolute inset-0 bg-[#131521] z-0" />
        <div className="absolute inset-x-0 top-0  h-24 md:h32 bg-white rounded-t-[40px] md:rounded-t-[120px] z-10 pb-24 md:pb-32" />
      </div>
    </>
  );
}
